import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SvgAssets } from "../../../components/icon/assets";
import { prompt } from "../../../components/modal/prompt";
import { ROOT_PATH } from "../../../routes/constants";
import { reset } from "../../auth/redux/auth-slice";
import IdleTimer from "./idle-timer";

interface IdleTimerLayoutProps {
  children: React.ReactNode;
}

const IdleTimerLayout: React.FC<IdleTimerLayoutProps> = ({ children }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const showPrompt = () => {
    const config = {
      icon: SvgAssets.notice,
      title: t("reminder_title"),
      message: t("Common.system_idle_for_15_minutes"),
      confirmButtonText: t("Common.confirm"),
      onConfirm: () => {
        navigate(`${ROOT_PATH}/login`);
      },
    };
    prompt(config);
  };

  const handleIdle = () => {
    if (sessionStorage.getItem("AUTH_TOKEN")) {
      sessionStorage.removeItem("AUTH_TOKEN");
      dispatch(reset());
      showPrompt();
    }
  };

  useEffect(() => {
    const handleClick = () => {
      if (!sessionStorage.getItem("AUTH_TOKEN")) {
        showPrompt();
      }
    };

    window.addEventListener("click", handleClick);
    return () => {
      window.removeEventListener("click", handleClick);
    };
  }, []);

  return (
    <>
      <IdleTimer onIdle={handleIdle} />
      {children}
    </>
  );
};

export default IdleTimerLayout;
